import { Box, styled } from '@mui/material'

export const StyledSwitcherBox = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
}))
